import "core-js/modules/es.function.name.js";
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3860ed82"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  style: {
    "margin": "auto",
    "display": "flex",
    "flex-direction": "row"
  }
};

var _hoisted_2 = /*#__PURE__*/_createStaticVNode("<p data-v-3860ed82><span data-v-3860ed82>报名截止时间：</span>2025年03月14日</p><p data-v-3860ed82><span data-v-3860ed82>参与对象：</span>销售、售后、研发、工程部等同事，我们期待你的加入。</p><p data-v-3860ed82><span data-v-3860ed82>讲解内容：</span>要求涵盖产品基本情况、价值、客户利益、优势、应用场景、参数差异、客户案例等方面，展现你的专业与深度。</p><p data-v-3860ed82><span data-v-3860ed82>产品范围：</span>包括工业清洗、热工学监测等类别的多个产品，具体以文末表格为准。</p><p data-v-3860ed82><span data-v-3860ed82>参与方式：</span>优先支持个人主动报名，也可以由各部门内部讨论后，选举产研岗、销售/市场岗、技术岗各1人参加产品讲解。</p><p data-v-3860ed82><span data-v-3860ed82>演讲方式：</span>每位讲解者有15分钟时间介绍产品，可使用PPT、视频、实物演示等多种方式，展现你的风采。</p><p style=\"margin-bottom:15px;\" data-v-3860ed82><span data-v-3860ed82>演讲时间：</span>以下10类产品的具体演讲时间，将根据报名人员的时间进行排期，逐一进行</p>", 7);

var _hoisted_9 = {
  style: {
    "font-weight": "600"
  }
};
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = ["innerHTML"];

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "font-weight": "600"
    }
  }, "研发：", -1);
});

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "font-weight": "600"
    }
  }, "工程/售后：", -1);
});

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "font-weight": "600"
    }
  }, "销售/市场：", -1);
});

var _hoisted_15 = /*#__PURE__*/_createTextVNode("报名");

var _hoisted_16 = {
  class: "dialog-footer"
};

var _hoisted_17 = /*#__PURE__*/_createTextVNode("确定");

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "dibu"
  }, " Copyright ©2024 深圳市捷汇多科技有限公司 ", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_table = _resolveComponent("el-table");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_form = _resolveComponent("el-form");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
    class: "main",
    style: _normalizeStyle('padding-top:' + $data.mainpadding + 'px;')
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["center", {
      'centerShow': $data.bwidth
    }])
  }, [_createElementVNode("div", {
    class: "fromstyle",
    style: _normalizeStyle($data.phoneShow ? 'padding: 30px;' : 'padding: 15px;')
  }, [_createElementVNode("h3", {
    style: _normalizeStyle([$data.phoneShow ? '' : 'font-size:22px;', {
      "margin-bottom": "15px"
    }])
  }, "公司产品深度剖析大赛报名", 4), _hoisted_2, _createVNode(_component_el_table, {
    data: $data.orderData,
    border: "",
    style: _normalizeStyle('width:' + $data.pmkd + ';'),
    size: "small",
    "scrollbar-always-on": true
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        prop: "yl1",
        label: "产品类型",
        width: $data.phoneShow ? "140px" : "220px",
        fixed: "left"
      }, {
        default: _withCtx(function (scope) {
          return [_createElementVNode("div", _hoisted_9, _toDisplayString(scope.row.yl1), 1), !$data.phoneShow ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            innerHTML: scope.row.cpmc
          }, null, 8, _hoisted_10)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["width"]), $data.phoneShow ? (_openBlock(), _createBlock(_component_el_table_column, {
        key: 0,
        prop: "cpmc",
        label: "产品名称",
        width: "220px"
      }, {
        default: _withCtx(function (scope) {
          return [_createElementVNode("div", {
            innerHTML: scope.row.cpmc
          }, null, 8, _hoisted_11)];
        }),
        _: 1
      })) : _createCommentVNode("", true), $data.phoneShow ? (_openBlock(), _createBlock(_component_el_table_column, {
        key: 1,
        prop: "xssc",
        label: "已报名人员",
        align: "center"
      }, {
        default: _withCtx(function (scope) {
          return [_createElementVNode("div", null, [_hoisted_12, _createTextVNode(_toDisplayString(scope.row.yf), 1)]), _createElementVNode("div", null, [_hoisted_13, _createTextVNode(_toDisplayString(scope.row.scsh), 1)]), _createElementVNode("div", null, [_hoisted_14, _createTextVNode(_toDisplayString(scope.row.xssc), 1)])];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
        prop: "xssc",
        label: "操作",
        align: "center",
        width: "125px"
      }, {
        default: _withCtx(function (scope) {
          return [_createElementVNode("div", null, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: function onClick($event) {
              return $options.sign(scope.row, 4);
            },
            size: "small"
          }, {
            default: _withCtx(function () {
              return [_hoisted_15];
            }),
            _: 2
          }, 1032, ["onClick"])])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data", "style"])], 4)], 2)])], 4), _createVNode(_component_el_dialog, {
    modelValue: $data.bus.dialogFormVisible,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
      return $data.bus.dialogFormVisible = $event;
    }),
    title: "填写信息",
    "close-on-click-modal": false,
    draggable: true
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_16, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: $options.baomin
      }, {
        default: _withCtx(function () {
          return [_hoisted_17];
        }),
        _: 1
      }, 8, ["onClick"])])];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_el_form, {
        model: $data.bus,
        ref: "ruleFormRef",
        "label-position": "top",
        "status-icon": ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form_item, {
            label: "姓名"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: $data.bus.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return $data.bus.name = $event;
                }),
                modelModifiers: {
                  trim: true
                },
                placeholder: "请输入您的姓名"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "要报名的分组"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_select, {
                modelValue: $data.bus.fz,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return $data.bus.fz = $event;
                }),
                class: "m-2",
                placeholder: "请选择分组"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_option, {
                    label: "研发",
                    value: "2"
                  }), _createVNode(_component_el_option, {
                    label: "工程/售后",
                    value: "1"
                  }), _createVNode(_component_el_option, {
                    label: "销售/市场",
                    value: "3"
                  })];
                }),
                _: 1
              }, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "研发-已报名"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: $data.bus.yf,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return $data.bus.yf = $event;
                }),
                modelModifiers: {
                  trim: true
                },
                disabled: ""
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "工程/售后-已报名"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: $data.bus.scsh,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return $data.bus.scsh = $event;
                }),
                modelModifiers: {
                  trim: true
                },
                disabled: ""
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "销售/市场-已报名"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: $data.bus.xssc,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                  return $data.bus.xssc = $event;
                }),
                modelModifiers: {
                  trim: true
                },
                disabled: ""
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["model"])];
    }),
    _: 1
  }, 8, ["modelValue"]), _hoisted_18]);
}